// Module
var code = `<!-- clCodeSample — referenced code sample.
     Data shape (from author):
         { methodId: "codeSample\$Name", language: "javascript", caption?: "markdown" }

     Pipeline normalization:
         methodId → resolved via DocsCodeSamples[methodId]() → \`code: "..."\` field
         code is HTML-entity-escaped before reaching the template so it can render
         inside <code> without being interpreted as markup.

     Resolved data at render time:
         { code, language, caption? }

     Syntax highlighting runs post-render via the existing hljs/prism integration,
     keyed by the language-* class on the <code> element. -->
<div class="block-cl-code-sample">
  {{#caption}}<div class="block-cl-code-sample__caption">{{caption}}</div>{{/caption}}
  <pre class="block-cl-code-sample__pre"><code class="block-cl-code-sample__code language-{{language}}" data-language="{{language}}">{{code}}</code></pre>
</div>
`;
// Exports
module.exports = code;